<template>
  <div :class="$style['form-stepper']">
    <Btn
      :class="$style['form-stepper__button']"
      before-input
      icon-only="System/arrow-down-s-line"
      @click.prevent="decrease" />
    <input
      v-model="inputValue"
      :class="$style['form-stepper__input']"
      type="number">
    <Btn
      :class="$style['form-stepper__button']"
      after-input
      icon-only="System/arrow-up-s-line"
      @click.prevent="increase" />
  </div>
</template>

<script setup>
const inputValue = defineModel({ type: Number, default: 1 })

const decrease = () => {
  if (inputValue.value < 2) { return }
  inputValue.value--
}

const increase = () => {
  inputValue.value++
}
</script>

<style lang="scss" module>
.form-stepper {
  align-items: stretch;
  display: inline-flex;
  line-height: 0;
  min-height:calc(var(--spacing ) * 5);

  &__input {
    background-color: var(--white);
    border: 1px solid var(--grey-lighter);
    border-radius: 0;
    box-shadow: none;
    font-size: var(--font-size);
    appearance: none;
    appearance: textfield;
    padding: var(--spacing);
    width: calc(calc(var(--spacing ) * 6));
    text-align: center;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      margin: 0;
      appearance: none;
    }
  }
}
</style>
